import { ZendraLocalizationServices } from '../../enums/abpLocalizationServices';
import { createLocalizationKey } from '../../utils/localization-utils';
import { IModal } from '../../zn-modal-wrapper/interfaces/IModal';
import { ActionOverRecordTypes } from '../enums/action-over-record-types';
import { ActionTypes } from '../enums/action-type';
import { IActionModal, IActionTrigger } from '../interfaces/IAction';

export function modalAction(
  id: number,
  name: string,
  actionOverRecordType: ActionOverRecordTypes,
  config: IModal,
  nameSpace: ZendraLocalizationServices
): IActionModal {
  return {
    id,
    name: createLocalizationKey(name, nameSpace),
    actionOverRecordType,
    actionType: ActionTypes.Modal,
    config,
  };
}

export function triggerAction(
  id: number,
  name: string,
  actionOverRecordType: ActionOverRecordTypes,
  nameSpace: ZendraLocalizationServices
): IActionTrigger {
  return {
    id,
    name: createLocalizationKey(name, nameSpace),
    actionOverRecordType,
    actionType: ActionTypes.Trigger,
  };
}

// Configuration factories
export function createFormModalConfig(overrides: Partial<IModal>): IModal {
  return {
    confirmLabel: createLocalizationKey('Save', ZendraLocalizationServices.LanguageService),
    dismissLabel: createLocalizationKey('Close', ZendraLocalizationServices.LanguageService),
    backdrop: 'static',
    size: 'md',
    ...overrides,
  };
}
export function createImportExcelModalConfig(overrides: Partial<IModal>): IModal {
  return {
    confirmLabel: createLocalizationKey('Confirm', ZendraLocalizationServices.LanguageService),
    dismissLabel: createLocalizationKey('Close', ZendraLocalizationServices.LanguageService),
    backdrop: 'static',
    size: 'md',
    ...overrides,
  };
}
